import { render } from "./Installation.vue?vue&type=template&id=8b9aceb8&scoped=true&ts=true"
import script from "./Installation.vue?vue&type=script&lang=ts"
export * from "./Installation.vue?vue&type=script&lang=ts"

import "./Installation.vue?vue&type=style&index=0&id=8b9aceb8&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9aceb8"]])

export default __exports__